
import chickenbiryani from './chickenbiryani.jpg'
import mutton from './mutton.jpg'
import tikka from './tikka.jpg'
import tandoori from './tandoori.jpg'
import nun from './nun.jpg'
import paneer from './paneer.jpg'
import muttonchap from './mutton chap.jpg'
import muttonboti from './muttonkebab.jpg'
import Cart from './Cart.js'
import $ from 'jquery'
import{useEffect} from 'react'
import alanBtn from '@alan-ai/alan-sdk-web';
import { useState } from 'react'

const Menu = () => {
  const [cart,setCart]=useState('');
  const [cart1 ,setCart1] =useState('');
  const [cart2 ,setCart2] =useState('');
  const [cart3,setCart3]= useState('');
  const [cart4,setCart4]= useState('');
  const [cart5,setCart5] =useState('');
  const [cart6, setCart6]= useState('');
  const [cart7,setCart7]= useState('');
  useEffect(()=>{
    alanBtn({
      key: '27472bc788f4e1f48b401ba46b9f6cdc2e956eca572e1d8b807a3e2338fdd0dc/stage',
      onCommand: (commandData) => {
        if (commandData.command === "chickenbiri") {
         setCart(commandData.data)
        }
        else if(commandData.command==="muttonbiri"){
          setCart1(commandData.data)
        }
        else if(commandData.command==="tikka"){
          setCart2(commandData.data)
        }
        else if(commandData.command==="tandoori"){
          setCart3(commandData.data)
        }
        else if(commandData.command==="muttonboti"){
          setCart4(commandData.data)
        }
        else if(commandData.command==="butter"){
          setCart5(commandData.data)
        }
        else if(commandData.command==="paneer"){
          setCart6(commandData.data)
        }
        else if(commandData.command==="muttonchap"){
          setCart7(commandData.data)
        }
        else if(commandData.command==="removechickenbiri"){
          setCart(commandData.data)
        }
        else if(commandData.command==="removemuttonbiri"){
          setCart1(commandData.data)
        }
        else if(commandData.command==="removetikka"){
          setCart2(commandData.data)
        }
        else if(commandData.command==="removetandoori"){
          setCart3(commandData.data)
        }
        else if(commandData.command==="removemuttonboti"){
          setCart4(commandData.data)
        }
        else if(commandData.command==="removebutter"){
          setCart5(commandData.data)
        }
        else if(commandData.command==="removepaneer"){
          setCart6(commandData.data)
        }
        else if(commandData.command==="removemuttonchap"){
          setCart7(commandData.data)
        }
      }
    
  });
    
    
},[])
   

  
    return (
        
        <div id="menu">
          <br/>
          <br />
          <br/>
          <br/>
          <div class="row">
         <div class="col s10 m3">
      <div class="card z-depth-5" style={{position:"relative" ,right:"-35px"}}>
        <div class="card-image">
          <img src={chickenbiryani}alt="chickenbiryani"></img>
          
          
        </div>
        <div class="card-content" style={{backgroundColor:"grey"}}>
        <h6 style={{fontFamily:"Monaco ,monospace"}}><b>Chicken Biryani</b></h6>
        
        <p><b>Price : 10$</b></p>
      
        
        
        </div>
       
      </div>
      </div>
      <div className="col s10 m3">
      <div class="card z-depth-5" style={{position:"relative",right:"-35px"}} >
        <div class="card-image">
          <img src={mutton}alt="muttonbiryani"></img>
        </div>
        <div class="card-content" style={{backgroundColor:"grey"}}>
        <h6 style={{fontFamily:"Monaco,Monospace"}}><b>Mutton Biryani</b></h6>
        
        <b>Price : 15$</b>
        </div>
        
       
      </div>
      </div>
      
      <div className="col s10 m3">
      <div class="card z-depth-5" style={{position:"relative",right:"-35px"}} >
        <div class="card-image">
          <img src={tikka}alt="tikkamasala"></img>
        </div>
        <div class="card-content" style={{backgroundColor:"grey"}}>
        <h6 style={{fontFamily:"Monaco,Monospace"}}><b>Tikka Butter Masala</b></h6>
        
        <b>Price : 18$</b>
        
        </div>
       
      </div>
      </div>
      
      <div className="col s10 m3">
      <div class="card z-depth-5" style={{position:"relative",right:"-35px"}} >
        <div class="card-image">
          <img src={tandoori}alt="tandoori"></img>
        </div>
        <div class="card-content" style={{backgroundColor:"grey"}}>
        <h6 style={{fontFamily:"Monaco,Monospace"}}><b>Tandoori</b></h6>
        
        <b>Price : 25$</b>

        </div>
       
      </div>
      </div>

      <div className="col s10 m3">
      <div class="card z-depth-5" style={{position:"relative",right:"-35px"}} >
        <div class="card-image">
          <img src={nun}alt="nun"></img>
        </div>
        <div class="card-content" style={{backgroundColor:"grey"}}>
        <h6 style={{fontFamily:"Monaco,Monospace"}}><b>Butter Nun</b></h6>
        
          <b>Price : 5$</b>
        </div>
       
      </div>
      </div>
      <div className="col s10 m3">
      <div class="card z-depth-5" style={{position:"relative",right:"-35px"}} >
        <div class="card-image">
          <img src={paneer}alt="paneer masala"></img>
        </div>
        <div class="card-content" style={{backgroundColor:"grey"}}>
        <h6 style={{fontFamily:"Monaco,Monospace"}}><b>Paneer Masala</b></h6>
        
        <b>Price : 15$</b>
        </div>
       
      </div>
      </div>
      <div className="col s10 m3">
      <div class="card z-depth-5" style={{position:"relative",right:"-35px"}} >
        <div class="card-image">
          <img src={muttonchap}alt="mutton chap"></img>
        </div>
        <div class="card-content" style={{backgroundColor:"grey"}}>
        <h6 style={{fontFamily:"Monaco,Monospace"}}><b>Mutton Chap</b></h6>
        
        <b>Price : 18$</b>
        </div>
       
      </div>
      </div>
      <div className="col s10 m3">
      <div class="card z-depth-5" style={{position:"relative",right:"-35px"}} >
        <div class="card-image">
          <img src={muttonboti}alt="Mutton kebab"></img>
        </div>
        <div class="card-content" style={{backgroundColor:"grey"}}>
        <h6 style={{fontFamily:"Monaco,Monospace"}}><b>Mutton boti Kebab</b></h6>
        
        <b>Price : 25$</b>
        </div>
       
      </div>
      </div>
       </div>
        <div>
          <Cart  name1="chicken biriyani" name2="Mutton Biryani" name3="Tikka Butter Masala" name4="Tandoori" name5="Mutton Boti Kebab" name6="Butter Nun" name7="Paneer Masala" name8="Mutton Chap"/>
        </div>


        <div style={{fontFamily:"Monaco,monspce",fontSize:"15px",color:"white"}}>
          <ul style={{color:"white",position:"relative",right:"-30px",fontFamily:"Monaco,monosapce",fontSize:"18px"}}>
            <li>
              {cart}
              
            </li>
            <br />
            <li style={{position:"relative",top:"-10px"}}>
              {cart1}
            </li>
            <li>
              {cart2}
            </li>
            <li>
              {cart3}
            </li>
            <li>
              {cart4}
            </li>
            <li>
              {cart5}
            </li>
            <li>
              {cart6}
            </li>
            <li>
              {cart7}
            </li>
          </ul>
         
           
           
         
        </div>
        </div>
        
      );
}
 
export default Menu;